"use client";

import React, {useMemo, useReducer} from "react";


const initialState = {
    setup: {
        options: [],
        rules: [],
        variables: [],
        product: {
            name: 'none',
            price: 0,
        },
        quantity: 1
    },
    currentConfiguration: {
        price: 0.00,
        priceFormulaPrice : 0.00,
        finalPrice: 0.00,
        finalPriceGrandTotal: 0.00,
        priceFormula: null,
        options: [],
        actions: [],
        variables: [],
        errors: []
    },
    itemId: null
};

const FrontendConfiguratorContext = React.createContext(initialState);

FrontendConfiguratorContext.displayName = 'FrontendConfiguratorContext';

const frontendConfiguratorReducer = (state, action) => {
    //console.log(action);
    switch (action.type) {


        case 'LOAD_STATE':
            return {
                ...state,
                setup: {
                    ...action.payload
                }
            };


        /*     case 'SET_OPTION':
                 return {
                     ...state,
                     currentConfiguration: {
                         ...state.currentConfiguration,
                         options: [
                             ...state.currentConfiguration.options.slice(0, action.payload.optionIndex),
                             action.payload.option,
                             ...state.currentConfiguration.options.slice(action.payload.optionIndex + 1)
                         ]
                     }
                 };


             case 'SET_VARIABLE':
                 return {
                     ...state,
                     currentConfiguration: {
                         ...state.currentConfiguration,
                         variables: [
                             ...state.currentConfiguration.variables.slice(0, action.payload.variableIndex),
                             action.payload.variable,
                             ...state.currentConfiguration.variables.slice(action.payload.variableIndex + 1)
                         ]
                     }
                 };*/

        case 'SET_CURRENT_CONF_OPTION':

            let option = state.setup.options.find(o => o.option_id === action.payload.optionId);

            if(!option) {
                console.error('option not found SET CURRENT OPTION aborted');
                return state;
            }

            let newCurrentOptionValue = {
                ...option,
                value: action.payload.value
            };

            let newOptions = [...state.currentConfiguration.options];

            let curOptionIndex = newOptions.findIndex(opt => opt.option_id === option.option_id);

            if(action.payload.value !== undefined && action.payload.value !== null) {
                if(typeof action.payload.value === 'string' && action.payload.value.length === 0) {
                    if (curOptionIndex !== -1) {
                        newOptions.splice(curOptionIndex, 1);
                    }
                }else {
                    if (curOptionIndex !== -1) {
                        newOptions[curOptionIndex] = newCurrentOptionValue;
                    } else {
                        newOptions.push(newCurrentOptionValue);
                    }
                }
            }else{
                if (curOptionIndex !== -1) {
                    newOptions.splice(curOptionIndex, 1);
                }
            }

            return {
                ...state,
                currentConfiguration: {
                    ...state.currentConfiguration,
                    options: newOptions
                }
            };

        case 'SET_CURRENT_CONF_ACTIONS':
            return {
                ...state,
                currentConfiguration: {
                    ...state.currentConfiguration,
                    actions: action.payload
                }
            };

        case 'SET_CURRENT_CONF_VARIABLE':

            let newVariables = [...state.currentConfiguration.variables];

            let curVariableIndex = newVariables.findIndex(v => v.variable_id === action.payload.variable.variable_id);


            if(curVariableIndex !== -1) {
                newVariables[curVariableIndex] = action.payload.variable;
            }else{
                newVariables.push(action.payload.variable);
            }

            return {
                ...state,
                currentConfiguration: {
                    ...state.currentConfiguration,
                    variables: newVariables
                }
            };

        case 'SET_CURRENT_CONF_VARIABLES':


            return {
                ...state,
                currentConfiguration: {
                    ...state.currentConfiguration,
                    variables: action.payload.variables
                }
            };

        case 'SET_CURRENT_CONF_PRICE':
            return {
                ...state,
                currentConfiguration: {
                    ...state.currentConfiguration,
                    price: action.payload
                }
            };
        case 'SET_CURRENT_CONF_PRICE_FORMULA_PRICE':
            return {
                ...state,
                currentConfiguration: {
                    ...state.currentConfiguration,
                    priceFormulaPrice: action.payload
                }
            };

        case 'SET_CURRENT_CONF_FINAL_PRICE':
            return {
                ...state,
                currentConfiguration: {
                    ...state.currentConfiguration,
                    finalPrice: action.payload
                }
            };
        case 'SET_CURRENT_CONF_FINAL_PRICE_GRAND_TOTAL':
            return {
                ...state,
                currentConfiguration: {
                    ...state.currentConfiguration,
                    finalPriceGrandTotal: action.payload
                }
            };


        case 'SET_ERRORS':
            return {
                ...state,
                currentConfiguration: {
                    ...state.currentConfiguration,
                    errors: action.payload.errors
                }
            }

        case 'SET_ITEM_ID':
            return {
                ...state,
                itemId: action.payload.itemId
            }

    }
}

export const FrontendConfiguratorProvider = (props) => {
    const [state, dispatch] = useReducer(frontendConfiguratorReducer, initialState);


    const loadState = (state) => {
        dispatch({
            type: 'LOAD_STATE',
            payload: state
        });
    }



    const setCurrentConfigurationOption = (optionId, value) => {
        dispatch({
            type: 'SET_CURRENT_CONF_OPTION',
            payload: {
                optionId,
                value
            }
        });
    };

    const loadOptionsPresets = (options) => {

        if(!options) {
            return;
        }

        options.map((opt) => {

            if(!state.setup.options) return;

            state.setup.options.map((setupOpt) => {
                if(setupOpt.option_id == opt.option_id) {
                    let value = null;
                    if(setupOpt.type==='drop_down'){
                        if(setupOpt.values) {
                            setupOpt.values.map((val) => {
                                if (val.option_type_id == opt.value) {
                                    value = val;
                                }
                            });
                        }
                    }else{
                        value = opt.value;
                    }

                    if(value !== null) {
                        setCurrentConfigurationOption(opt.option_id, value);
                    }
                }
            });

        });

    };


    const setCurrentConfigurationActions = (actions) => {
        dispatch({
            type: 'SET_CURRENT_CONF_ACTIONS',
            payload: actions
        });
    };


    const setCurrentConfigurationVariable = (variable) => {
        dispatch({
            type: 'SET_CURRENT_CONF_VARIABLE',
            payload: {
                variable
            }
        });
    };
    const setCurrentConfigurationVariables = (variables) => {
        dispatch({
            type: 'SET_CURRENT_CONF_VARIABLES',
            payload: {
                variables
            }
        });
    };

    const setCurrentConfigurationPrice = (price) => {
        dispatch({
            type: 'SET_CURRENT_CONF_PRICE',
            payload: price
        });
    };

    const setCurrentConfigurationPriceFormulaPrice = (price) => {
        dispatch({
            type: 'SET_CURRENT_CONF_PRICE_FORMULA_PRICE',
            payload: price
        });
    };

    const setCurrentConfigurationFinalPrice = (finalPrice) => {
        dispatch({
            type: 'SET_CURRENT_CONF_FINAL_PRICE',
            payload: finalPrice
        });
    }
    const setCurrentConfigurationFinalPriceGrandTotal = (finalPrice) => {
        dispatch({
            type: 'SET_CURRENT_CONF_FINAL_PRICE_GRAND_TOTAL',
            payload: finalPrice
        });
    }

    const setErrors = (errors) => {
        dispatch({
            type: 'SET_ERRORS',
            payload: {
                errors
            }
        });
    }

    const setItemId = (itemId) => {
        dispatch({
            type: 'SET_ITEM_ID',
            payload: {
                itemId
            }
        });
    }

    const memoizedContextValue = useMemo(() => ({
        ...state,
        loadState,
        setCurrentConfigurationOption,
        setCurrentConfigurationActions,
        setCurrentConfigurationVariable,
        setCurrentConfigurationVariables,
        setCurrentConfigurationPrice,
        setCurrentConfigurationFinalPrice,
        setErrors,
        loadOptionsPresets,
        setItemId,
        setCurrentConfigurationPriceFormulaPrice,
        setCurrentConfigurationFinalPriceGrandTotal

    }), [state]);

    return (
        <FrontendConfiguratorContext.Provider value={memoizedContextValue}>
            {props.children}
        </FrontendConfiguratorContext.Provider>
    );

}


export const useFrontendConfiguratorContext = () => {
    return React.useContext(FrontendConfiguratorContext);
}


export const GlobalFrontendConfiguratorContext = ({children}) => <FrontendConfiguratorProvider>{children}</FrontendConfiguratorProvider>;
